import {
    OpType,
    SubscriptionMessage
} from '@aws-amplify/datastore';

import { ContextAwareIdentifier } from '../design/document/ContextAwareIdentifier';
import { DataStore } from 'aws-amplify';
import { Location } from '../../models';
import { ModelType } from '../design/document/ModelType';
import { StateContext } from '../design/document/state/StateContext';
import { locationByLocationIdentifierSelectorFamily } from '../design/document/state/DocumentState';
import { useRecoilCallback } from 'recoil';

let subscription: ZenObservable.Subscription | undefined;

export const useLocationSubscription = () => {
    const handleLocationUpdate = useRecoilCallback(({ set, reset }) => async (message: SubscriptionMessage<Location>, context: StateContext) => {
        const locationIdentifier = new ContextAwareIdentifier(message.element.id, context, ModelType.LOCATION);

        if (message.opType === OpType.DELETE) {
            reset(locationByLocationIdentifierSelectorFamily(locationIdentifier));
            return;
        }

        const location = message.element;
        set(locationByLocationIdentifierSelectorFamily(locationIdentifier), location);
    });

    const subscribe = async (propertyId: string) => {
        subscription = DataStore.observe(Location, (location) =>
            location.propertyId("eq", propertyId)
        ).subscribe({
            next: (message: SubscriptionMessage<Location>) => {
                handleLocationUpdate(message, StateContext.INSPECTION);
            },
            error: (error) => console.warn(error)
        });
    };

    const unsubscribe = () => {
        subscription?.unsubscribe();
    };

    return { subscribe, unsubscribe };
};